import { createFileRoute } from '@tanstack/react-router'

import { CourseEditView } from '@/modules/coursesManagement'

export const Route = createFileRoute(
  '/_auth/courses-management/$courseId/edit'
)({
  component: CourseEditView
})
